<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="8" class="content_category rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6">
              <v-select
                  readonly
                  :value="'Bosch'"
                  background-color="#EDF2F7"
                  filled
                  :items="['Foo', 'Bar','Bosch']"
                  label="Chọn nhãn hàng"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  readonly
                  :value="categoryDetail.name"
                  background-color="#EDF2F7"
                  filled
                  label="Tên"
                  placeholder="Nhập tên category"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  readonly
                  :value="categoryDetail.slug"
                  background-color="#EDF2F7"
                  filled
                  label="Slug"
                  placeholder="Nhập tên slug"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                  readonly
                  background-color="#EDF2F7"
                  filled
                  label="Mô tả"
                  placeholder="Nhập tên mô tả"
                  v-html="categoryDetail.description"
              >
              </v-textarea>
            </v-col>
            <v-col cols="6">
              <img style="width:100%" :src="categoryDetail.photo_url_path ? categoryDetail.photo_url_path : require('@/assets/images/bi_image.png')" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_DETAIL_CATEGORY_POST } from "@/store/modules/category_post";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      page: "Quản lý category",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý bài viết",
          disabled: true,
        },
        {
          text: "Quản lý category",
          disabled: true,
        },
        {
          text: "Chi tiết category",
          disabled: true,
        },
      ],

    };
  },
  computed: {
    ...mapGetters({
      categoryDetail: "categoryPostDetail",
      categories: "categoryPost"
    })
  },
  async created() {
    await this.$store.dispatch(GET_DETAIL_CATEGORY_POST,  this.$route.params.id);
    console.log(this.categoryDetail,'eeee')
  },
  methods:{

  }
};
</script>
<style>
.content_category {
  background: #ffffff !important;
}
</style>